"use client";
import { useEffect, useRef, useState } from "react";
import { ANIMATION_GLOBAL_OFFSET } from "@/lib/animationConfig";

export default function AnimatedGrid({ children, className = "", delay = 0.1 }) {
	// Rendu du composant : chaque enfant est enveloppé dans un div avec animation conditionnelle
	// Item component defined outside the map
	const Item = ({ child, i, delay }) => {
		const ref = useRef(null);
		const [inView, setInView] = useState(false);

		useEffect(() => {
			const observer = new IntersectionObserver(
				([entry]) => {
					setInView(entry.isIntersecting);
				},
				{ threshold: 0, rootMargin: '0% 0% -15% 0%' }
			);

			const startObserving = () => {
				if (!document.body.classList.contains("page-enter") && ref.current) {
					observer.observe(ref.current);
				}
			};

			const mutation = new MutationObserver(() => {
				startObserving();
			});

			mutation.observe(document.body, { attributes: true, attributeFilter: ["class"] });

			startObserving();

			return () => {
				observer.disconnect();
				mutation.disconnect();
			};
		}, []);

		const [delayIndex, setDelayIndex] = useState(0);

		useEffect(() => {
			const all = document.querySelectorAll(".animated-grid-item");
			let count = 0;
			for (let j = 0; j < i; j++) {
				if (all[j]?.offsetTop === all[i]?.offsetTop) count++;
			}
			setDelayIndex(count);
		}, []);

		return (
			<div
				ref={ref}
				className={`animated-grid-item ${inView ? "inview" : ""}`}
			>
				<div style={inView ? { animationDelay: `${ANIMATION_GLOBAL_OFFSET + delayIndex * delay}s` } : {}}>
					{child}
				</div>
			</div>
		);
	};

	return (
		<div className={`animated-grid ${className}`}>
			{Array.isArray(children)
				? children.map((child, i) => {
						return <Item key={i} child={child} i={i} delay={delay} />;
				  })
				: children}
		</div>
	);
}